<template>
  <div class="countyProfile">
    <h3>
      <span class="countyproject">什么是县域项目？</span>
    </h3>
    <div class>
      <p
        style="line-height:35px;font-size:18px;text-align:center"
      >2020年美菜网大力开拓发展县域生鲜市场，开启新版县域经营模式，现面向全国招募县域代理商。由县域代理商负责在当地县域的营销、配送，开展餐饮B2B及住家B2C业务，共享万亿级餐饮供应链县域市场。</p>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
export default {
  name: "countyProfile",
  data() {
    return {
      dialogVisbility: false
    };
  }
};
</script>

<style lang="scss" scoped>
.countyProfile {
  width: 1000px;
  margin: 80px auto;
  .countyproject {
    font-size: 30px;
    color: #333333;
    font-weight: 600;
  }
  h3 {
    text-align: center;
    margin-bottom: 50px;
    font-size: 18px;
  }
}
</style>
